var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('LabelAbbreviations'),_c('v-card-actions',[_c('v-spacer'),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":_vm.close}},[_vm._v("Close")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }